module.exports = __webpack_public_path__ + "img/ideal-logo.05670b7b.svg";